import {Component, EventEmitter, Input, Output, OnDestroy, OnInit} from '@angular/core'
import {NavigationStart, Router} from '@angular/router'
import {filter, takeUntil} from 'rxjs/operators'
import {Subject} from 'rxjs'
import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes'

@Component({
  selector: 'cft-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
})
export class DialogComponent<Output> implements OnInit, OnDestroy {
  @Input() title?: string
  @Input() size: 'sm' | 'md' | 'lg' = 'md'
  @Input() closeOnRouteChange = true
  @Input() canBeClosed = true
  @Output() readonly closed = new EventEmitter<Output | undefined>()

  readonly faTimes = faTimes
  private readonly unsubscribe$ = new Subject<void>()

  constructor(private readonly router: Router) {}

  close(data?: Output): void {
    this.closed.emit(data)
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  ngOnInit(): void {
    if (this.closeOnRouteChange) {
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationStart),
          takeUntil(this.unsubscribe$),
        )
        .subscribe(() => {
          this.close()
        })
    }
  }
}
